'use client'

import { HorseSilhouette, KuficMark, ChromeShape } from './Decorations'

// Deep-blue banner used by the About sub-pages and the Business page.
// Matches the design mockups: fingerprint/grid texture, faint "Ch" + "R"
// letters, a square-kufic mark top-right, a dark rearing horse, a glossy
// chrome shape bottom-right, an orange baseline glow and the chat bubble.
export default function BlueHero({ title }: { title: string }) {
  return (
    <section
      className="relative w-full overflow-hidden"
      style={{
        minHeight: '300px',
        background:
          'linear-gradient(135deg, #050d2e 0%, #0a1a6e 30%, #1530a8 55%, #0a1a6e 75%, #050d2e 100%)',
      }}
    >
      {/* fingerprint rings */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse 60% 85% at 52% 50%, transparent 18%, rgba(255,255,255,0.04) 23%, transparent 28%, rgba(255,255,255,0.035) 33%, transparent 38%, rgba(255,255,255,0.03) 43%, transparent 48%, rgba(255,255,255,0.022) 53%, transparent 58%, rgba(255,255,255,0.016) 63%, transparent 68%)',
          zIndex: 0,
        }}
      />
      {/* faint grid */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
          zIndex: 0,
        }}
      />

      {/* large faint "Ch" left */}
      <div
        style={{
          position: 'absolute',
          left: '-10px',
          top: '-24px',
          fontSize: '260px',
          fontWeight: 900,
          color: 'transparent',
          WebkitTextStroke: '1.5px rgba(255,255,255,0.10)',
          lineHeight: 1,
          zIndex: 1,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      >
        Ch
      </div>

      {/* faint "R" / iq letters right */}
      <div
        style={{
          position: 'absolute',
          right: '6px',
          bottom: '-14px',
          fontSize: '180px',
          fontWeight: 900,
          color: 'transparent',
          WebkitTextStroke: '1.5px rgba(255,255,255,0.07)',
          lineHeight: 1,
          zIndex: 1,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      >
        iq
      </div>

      {/* kufic mark top-right */}
      <KuficMark
        style={{
          position: 'absolute',
          top: '26px',
          right: '70px',
          width: '64px',
          height: '64px',
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />

      {/* dark horse */}
      <HorseSilhouette
        style={{
          position: 'absolute',
          top: '34px',
          right: '96px',
          width: '150px',
          height: '160px',
          opacity: 0.7,
          zIndex: 1,
          pointerEvents: 'none',
        }}
      />

      {/* glossy chrome shape bottom-right */}
      <ChromeShape
        style={{
          position: 'absolute',
          bottom: '0px',
          right: '40px',
          width: '120px',
          height: '90px',
          opacity: 0.9,
          zIndex: 2,
          pointerEvents: 'none',
        }}
      />

      {/* orange baseline glow */}
      <div
        className="absolute bottom-0 left-0 right-0"
        style={{
          height: '2px',
          background:
            'linear-gradient(90deg, transparent, rgba(255,140,0,0.45), transparent)',
          zIndex: 2,
        }}
      />

      {/* chat bubble */}
      <div
        className="absolute flex items-center justify-center rounded-full"
        style={{
          bottom: '20px',
          right: '20px',
          width: '48px',
          height: '48px',
          background: '#f97316',
          boxShadow: '0 4px 16px rgba(249,115,22,0.45)',
          zIndex: 20,
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </div>

      {/* title */}
      <div
        className="relative z-10 flex items-center justify-center"
        style={{ minHeight: '300px' }}
      >
        <h1
          style={{
            fontSize: 'clamp(26px, 5vw, 40px)',
            fontWeight: 900,
            color: '#fff',
            letterSpacing: '0.12em',
            textAlign: 'center',
            padding: '0 20px',
            textShadow: '0 2px 20px rgba(0,0,0,0.4)',
          }}
        >
          {title}
        </h1>
      </div>
    </section>
  )
}
